(function () {
  var COLOR_MAP = {
    black: '#1A1A1A', schwarz: '#1A1A1A', noir: '#1A1A1A',
    white: '#FFFFFF', weiss: '#FFFFFF', 'weiß': '#FFFFFF', blanc: '#FFFFFF',
    gray: '#999999', grey: '#999999', gris: '#999999', grau: '#999999',
    blue: '#3B5A82', bleu: '#3B5A82', blau: '#3B5A82', navy: '#1F2A44', marine: '#1F2A44',
    red: '#A13B3B', rouge: '#A13B3B', rot: '#A13B3B',
    green: '#4A5D45', vert: '#4A5D45', grun: '#4A5D45',
    beige: '#D8C9AE',
    pink: '#D98BA7', rose: '#D98BA7',
    purple: '#6B4E71', violet: '#6B4E71', lila: '#6B4E71',
    yellow: '#D9B44A', jaune: '#D9B44A', gelb: '#D9B44A',
    skin: '#E0BFA0', peau: '#E0BFA0', nude: '#E0BFA0',
    brown: '#6B4A3A', marron: '#6B4A3A', braun: '#6B4A3A'
  };

  function matchColor(part) {
    var clean = part.toLowerCase().trim().replace(/[^a-zäöüß]/g, '');
    if (COLOR_MAP[clean]) return COLOR_MAP[clean];
    for (var key in COLOR_MAP) {
      if (clean.indexOf(key) !== -1) return COLOR_MAP[key];
    }
    return null;
  }

  function styleSwatch(input) {
    var label = input.parentElement ? input.parentElement.querySelector('label[for="' + input.id + '"]') : document.querySelector('label[for="' + input.id + '"]');
    if (!label) return;

    var parts = input.value.split('/').map(function (p) { return p.trim(); }).filter(Boolean);
    var colors = parts.map(matchColor).filter(Boolean);

    if (colors.length === 0) return;

    label.classList.add('ts-swatch-circle');
    if (colors.length === 1) {
      label.style.background = colors[0];
      if (colors[0].toLowerCase() === '#ffffff') label.classList.add('ts-swatch-circle--light');
    } else {
      label.style.background = 'linear-gradient(135deg, ' + colors[0] + ' 50%, ' + colors[1] + ' 50%)';
    }
  }

  var COLOR_OPTION_NAMES = ['color', 'couleur', 'farbe', 'colore', 'kleur'];

  function isColorOption(input) {
    var name = (input.dataset.optionName || '').toLowerCase().trim();
    return COLOR_OPTION_NAMES.indexOf(name) !== -1;
  }

  function applyAll() {
    document.querySelectorAll('input[data-option-name]').forEach(function (input) {
      if (isColorOption(input)) styleSwatch(input);
    });
  }

  function init() {
    applyAll();

    // Dawn replaces the whole variant-selects DOM node (via view-transition) whenever
    // a variant is selected, which wipes out the classes/inline styles we added above.
    // Re-apply the swatch styling whenever that happens.
    if ('MutationObserver' in window) {
      var observer = new MutationObserver(function (mutations) {
        var shouldReapply = mutations.some(function (m) {
          return m.type === 'childList' && (m.addedNodes.length || m.removedNodes.length);
        });
        if (shouldReapply) applyAll();
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
